module.exports = __webpack_public_path__ + "img/smc-logo.1a1b6842.png";